import FetchHelpers from '../../../utils/FetchHelpers';
import formUrl from '../../../utils/routes';

export default {
  load(membershipId) {
    const url = formUrl(`/api/v1/admin/memberships/${membershipId}/logs`);

    return FetchHelpers.get(url);
  },
};
